module.exports = __webpack_public_path__ + "static/media/5_15.726743e9.png";